<template>
	<aside
		v-if="nextArtInFlow && nextArtInFlow.ctgryUrl"
		:class="['module', 'module-next-article-ai', 'single-link']"
	>
		<a
			:href="nextArtInFlow.ctgryUrl"
			v-metric="{module: `cat-${nextArtInFlow.category}`}"
		>
			<span class="link-text">
				Next in {{ nextArtInFlow.ctgryTitle }}
			</span>
			<i class="webmd-icon-right-arrow single"></i>
		</a>
	</aside>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';
import getEnvStore from 'webmd-cms-store/src/store/helpers/utils.es6';
import shuffle from 'lodash/shuffle';
import axios from 'axios';
import oauth from 'webmd-oauth/src/index.es6';

export default {
	name: 'NextArticleNavAi',
	props: {
		isDev: {
			type: Boolean,
			default: false,
		},
		nextArticleData: {
			type: Object,
			default: () => ({}),
		},
		topicName: {
			type: String,
			required: true,
		}
	},

	data() {
		return {
			metrics: {
				module: 'cat',
			},
			moduleByChronicId: {},
			moduleData: {},
			nextArtInFlow: {},
			nextArtData: {},
			showAllArticles: false,
			omnitureVal: ''
		};
	},
	created() {
		this.store = useStore(this.$pinia);
		this.nextArtInFlow = this.nextArticleData;
		if (this.store.flow.flowInfo.freeflow) {
			this.nextArtInFlow.ctgryTitle = this.store.pagedata.omniture.s_channel_health;
			this.nextArtInFlow.ctgryUrl = this.nextArtInFlow.friendlyUrl;
			this.nextArtInFlow.category = 'flow';
		}
	},

	methods: {
		/**
		 * Gets next article recommendation from Adobe activity
		 * @returns {object} object with next asset
		 */
		// eslint-disable-next-line consistent-return
		async getNextAssetRec() {
			const self = this;
			const busRef = self.store.pagedata.omniture.s_business_reference.toLowerCase() || '';
			const topicVal = self.store.pagedata.omniture.s_topic;
			const assetIdVal = self.store.pagedata.omniture.s_asset_id;
			const urlDomain = window.location.host.toLowerCase();
			const domainUrl = getEnvStore.getEnvironment(urlDomain).servicedomain;
			const apiUrl = `${domainUrl}/kapi/popular?topic=${topicVal}` || '';
			// alloy artcicle flow  for infinite
			if (busRef.includes('news') || busRef === 'feature' || busRef === 'medical reference') {
				let dataObj = false;
				try {
					const oauthHeaders = oauth.generate();
					const response = await axios.get(apiUrl, { headers: oauthHeaders });
					const responsedataObj = response.data;
					const key = 'assetId';
					dataObj = [...new Map(responsedataObj.map((item) => [item[key], item])).values()];
					if (dataObj) {
						dataObj = shuffle(dataObj);
						if (dataObj[0].assetId === assetIdVal) {
							// eslint-disable-next-line prefer-destructuring
							dataObj = dataObj[1];
						} else {
							// eslint-disable-next-line prefer-destructuring
							dataObj = dataObj[0];
						}
						return {
							assetId: dataObj.assetId || '',
							capId: dataObj.capId || '',
							channelId: dataObj.channelId || '',
							contentType: dataObj.type || '',
							title: this.topicName || '',
							url: dataObj.url || ''
						};
					}
				} catch (error) {
					console.error('Error:', error);
				}
			}else {
				return false;
			}
		},
	},

	mounted() {
		const self = this;

		if (this.$route && this.$route.query && this.$route.query.qap) {
			this.qap = true;
		}
		if (!this.nextArtInFlow?.ctgryTitle && !this.nextArtInFlow?.ctgryUrl && !self.qap) {
			setTimeout(() => {
				self.getNextAssetRec().then((res) => {
					self.nextArtInFlow = !self.nextArtInFlow ? {} : self.nextArtInFlow;
					self.nextArtInFlow = {
						ctgryTitle: res.title,
						ctgryUrl: res.url,
						category: 'arec'
					};
				});
			}, 3500);
		}
	},
};
</script>

<style lang="scss">
@import 'stylesheets/nextartnav-ai.scss';
</style>
